import client from "../client";

export interface GameinhouseOpenBoxBetResponse {
  id: number;
  type: string;
  percentage: number;
  img: string;
  disable: boolean;
  amount: number;
  reward_type_id: number;
}

export default function API(): Promise<GameinhouseOpenBoxBetResponse> {
  return client
    .post(`gameinhouse/openbox/bet`)
    .then((response) => response.data)
    .then((json) => {
      return json;
    });
}
